'use client'

import { MdOutlineSupportAgent } from 'react-icons/md'
import { show } from '@intercom/messenger-js-sdk'
import { Transition } from '@wiggui/ds/Transition'
import { Tooltip } from '@wiggui/ds/Tooltip'
import { Flex } from '@wiggui/ds/Flex'
import { composeClasses } from '../../utils/src/strings'
import { INTERCOM_LAUNCHER_BUTTON_ID } from '../constants/intercom-id'

interface IntercomButtonProps {
  showText?: boolean
  className?: string
  iconClassName?: string
  containerIconClassName?: string
  containerTextClassName?: string
  variant?: 'light' | 'dark'
  strategyPosition?: 'fixed' | 'static'
}

const assignedColorsByVariant = {
  light: {
    backgroundColor: 'bg-surface-gray-10',
    hoverColor: 'hover:bg-[#DEE5F1]',
    activeColor: 'active:bg-[#b6bbc5]',
    textColor: 'text-primary'
  },
  dark: {
    backgroundColor: 'bg-[#222222]',
    hoverColor: 'hover:bg-[#2D3748]',
    activeColor: 'active:bg-[#1A202C]',
    textColor: 'text-white'
  }
}

export const IntercomButton = ({
  showText = false,
  className,
  iconClassName,
  containerIconClassName,
  containerTextClassName,
  variant = 'light',
  strategyPosition = 'static'
}: IntercomButtonProps) => {
  const { backgroundColor, hoverColor, activeColor, textColor } =
    assignedColorsByVariant[variant]

  const handleClick = () => {
    show()
  }

  if (strategyPosition === 'fixed') {
    return (
      <Flex
        items="center"
        justify="start"
        wFull
        className={composeClasses(
          className,
          'fixed bottom-5 z-3 right-5 max-w-[48px] max-h-[48px]'
        )}
      >
        <Tooltip content="Soporte" className="!w-full">
          <button
            type="button"
            id={INTERCOM_LAUNCHER_BUTTON_ID}
            onClick={handleClick}
            className={composeClasses(
              backgroundColor,
              hoverColor,
              activeColor,
              'gap-3 flex items-center justify-center w-full h-[48px] shadow-x1 rounded-full transition-colors duration-300 ease-in-out'
            )}
          >
            <span
              className={composeClasses(
                'group-active:font-semibold flex items-center justify-center',
                textColor,
                containerIconClassName
              )}
            >
              <MdOutlineSupportAgent
                className={composeClasses(
                  iconClassName || 'min-w-[24px] min-h-[24px]'
                )}
              />
            </span>
          </button>
        </Tooltip>
      </Flex>
    )
  }

  return (
    <button
      type="button"
      id={INTERCOM_LAUNCHER_BUTTON_ID}
      onClick={handleClick}
      className={composeClasses(
        className,
        backgroundColor,
        hoverColor,
        activeColor,
        'rounded-xl gap-3 w-full flex items-center justify-start transition-colors duration-300 ease-in-out'
      )}
    >
      <span
        className={composeClasses(
          'group-active:font-semibold flex items-center justify-center',
          textColor,
          containerIconClassName
        )}
      >
        <MdOutlineSupportAgent
          className={composeClasses(
            iconClassName || 'min-w-[18px] min-h-[18px]'
          )}
        />
      </span>
      <Transition
        duration={300}
        show={showText}
        className={composeClasses('w-full', containerTextClassName)}
      >
        <p
          className={composeClasses(
            'group-active:text-body-bold-m',
            'text-body-m whitespace-nowrap text-ellipsis overflow-hidden w-full text-left max-w-[90px]',
            textColor
          )}
        >
          Soporte
        </p>
      </Transition>
    </button>
  )
}
export default IntercomButton
